import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import bg from '../assets/wanderlustbg.webp';
import BlogFeed from '../components/blog-feed';
import PostCard from '../components/post-card';
import Post from '../types/post-type';
import { PostCardSkeleton } from '../components/skeletons/post-card-skeleton';
import ThemeToggle from '../components/theme-toggle-button';
import AddIcon from '../assets/svg/add-icon-white.svg';
import '../assets/custom.styles.css';
import Footer from '../components/footer';
import logo from '../assets/logo_viva_viajando_transparente.png'
import React from 'react';
import ReactGA from 'react-ga4';
import { jwtDecode } from "jwt-decode";
import GoogleLogin from '../components/google-login';
import DocumentMeta from 'react-document-meta';

const gaId = process.env.REACT_APP_GA_ID || ''; // Provide a default value if REACT_APP_GA_ID is undefined
ReactGA.initialize(gaId);
ReactGA.send({ hitType: "pageview", page: "/Home", title: "Página Inicial" });


function HomePage() {
  const navigate = useNavigate();
  const [posts, setPosts] = useState<Post[]>([]);
  const [loggedUser, setLoggedUser] = useState('');
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'pt-br');
  const [triedLogin, setTriedLogin] = useState(false);


  const meta = {
    title: 'Blog Viva Viajando',
    description: 'Blog Viva Viajando. Nesse blog você vai encontrar textos sobre nossas viagens, dicas de como organizar a sua e muito mais.',
    canonical: window.location.href,
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_PATH + '/api/posts')
      .then((response) => {
        setPosts(response.data);
        console.log('Posts retrieved')
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    const gtoken = localStorage.getItem('g-token');
    setTriedLogin(true);
    if (gtoken !== null) {
      const decoded: { email: string } = jwtDecode(gtoken as string);
      setLoggedUser(decoded.email);
      
    }
  }, []);

  const authUsers = [
    'vabatista@gmail.com',
    'gabi.estrella@yahoo.com'
  ]

  return (
    <div className="w-full cursor-default bg-light dark:bg-dark">
      <DocumentMeta {...meta}></DocumentMeta>
      <div
        style={{ backgroundImage: `url(${bg})` }}
        className="relative -mt-2 h-[100px] bg-cover bg-fixed bg-center"
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="absolute inset-0 flex flex-col px-4 py-8 text-slate-50 md:px-16">
          <div className="flex w-full justify-between">
            <div>
               <img src={logo} alt="Logo" style={{height: 85}} />
            </div>  
            <div className="hidden flex max-h-20 px-4 items-left justify-between text-2xl font-semibold md:inline-block">
              Viva Viajando
            </div>
            <div className="flex justify-between px-2">
            {loggedUser === '' && triedLogin ? (<GoogleLogin setUserFunc={setLoggedUser} />) : authUsers.includes(loggedUser) ? (
              <>
              <button
                  className="hidden max-h-12 rounded border border-slate-50 px-4 py-2 hover:bg-slate-500/25 md:inline-block"
                  onClick={() => {
                    navigate('/add-blog');
                  }}
                >
                  Novo post
                </button>
                <button
                  className="px-0 py-0 min-h-10 max-h-12 hover:bg-slate-500/25 md:hidden"
                  onClick={() => {
                    navigate('/add-blog');
                  }}
                >
                   <img className="h-10 w-10" src={AddIcon} alt="Novo Post" />
                </button>
                </>
              ) : <></>}
              <div className="flex max-h-12 items-center justify-end px-2 py-2 md:px-10 space-x-3">
                <ThemeToggle />
                <div className="flex items-center space-x-1 ml-2 bg-slate-800/40 rounded-full p-1 border border-slate-600/35">
                  <button
                    onClick={() => {
                      localStorage.setItem('lang', 'pt-br');
                      setLang('pt-br');
                      window.dispatchEvent(new Event('storage'));
                    }}
                    className={`p-1 rounded-full hover:scale-110 transition-transform ${lang === 'pt-br' ? 'bg-slate-700 ring-2 ring-blue-500' : 'opacity-60 hover:opacity-100'}`}
                    title="Português"
                  >
                    <img src="https://flagcdn.com/w40/br.png" className="h-4 w-6 object-cover rounded-sm" alt="BR" />
                  </button>
                  <button
                    onClick={() => {
                      localStorage.setItem('lang', 'en');
                      setLang('en');
                      window.dispatchEvent(new Event('storage'));
                    }}
                    className={`p-1 rounded-full hover:scale-110 transition-transform ${lang === 'en' ? 'bg-slate-700 ring-2 ring-blue-500' : 'opacity-60 hover:opacity-100'}`}
                    title="English"
                  >
                    <img src="https://flagcdn.com/w40/gb.png" className="h-4 w-6 object-cover rounded-sm" alt="EN" />
                  </button>
                </div>
              </div>
    
            </div>
          </div>
        </div>
      </div>
      <div className="mx-4 md:mx-8 lg:mx-16">
        <BlogFeed />
        <h1 className="text-xl sm:pb-0 pb-4 font-semibold dark:text-dark-primary">Todos os textos</h1>
        <div className="flex flex-wrap">
          {posts.length === 0
            ? Array(8)
                .fill(0)
                .map((_, index) => <PostCardSkeleton key={index} />)
            : posts.map((post) => <PostCard key={post._id} post={post} />)}
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default HomePage;
